import { render, staticRenderFns } from "./AppointmentSelector.vue?vue&type=template&id=bb95915c&scoped=true"
import script from "./AppointmentSelector.vue?vue&type=script&lang=js"
export * from "./AppointmentSelector.vue?vue&type=script&lang=js"
import style0 from "./AppointmentSelector.vue?vue&type=style&index=0&id=bb95915c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb95915c",
  null
  
)

export default component.exports